import React from "react";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";

import { SiteRoute } from "../routes/site";

import LogoIcon from "../resources/images/eningo-icon-yellow.png";
import BackgroundImage from "../resources/images/background-image-1.jpg";

import { ItemContainerAnimation } from "../pandora/animations";
import {
  HorizontalFlex,
  VerticalFlex,
  ShadowLayer,
  LinkButton,
  Logo,
} from "../pandora/styled";

const Background = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-image: url(${BackgroundImage});
  background-size: cover;
`;

const Container = styled(VerticalFlex)`
  position: relative;
  width: 20%;
  min-width: 350px;
  height: 100%;
  box-sizing: border-box;
`;

const LoginContainer = styled(VerticalFlex)`
  margin-top: 20%;
  width: 300px;
  height: auto;
  padding: 25px;
  border-radius: 5px;
  align-items: center;

  background: rgba(44, 50, 58, 0.6);
  animation: ${ItemContainerAnimation} 0.8s 1;
`;

const Title = styled("h1")<{ size: number; bold: boolean; css?: string }>`
  margin: auto;
  margin-top: 10px;
  max-width: 60%;

  text-align: center;
  font-size: ${(props) => props.size}px;
  font-weight: ${(props) => (props.bold ? "bold" : "normal")};
  font-family: "Montserrat";
  color: white;

  ${(props) => props.css ?? ""}
`;

const ErrorView = (): React.ReactElement => {
  const location = useLocation();

  return (
    <Background>
      <ShadowLayer>
        <Container>
          <LoginContainer>
            <Logo src={LogoIcon} />
            <Title
              size={25}
              bold={true}
              css={"margin-top: 20px; margin-bottom: 20px;"}
            >
              Oh boy!
            </Title>
            <Title size={13} bold={false}>{`Sidan "${location.pathname.replace(
              "/",
              ""
            )}" kunde inte hittas.`}</Title>
            <HorizontalFlex
              css={"justify-content: center; margin-top: 40px; width: 100%;"}
            >
              <Link to={SiteRoute.Dashboard} style={{ textDecoration: "none" }}>
                <LinkButton>Dashboard</LinkButton>
              </Link>
              <Link to={SiteRoute.Login} style={{ textDecoration: "none" }}>
                <LinkButton>Logga in</LinkButton>
              </Link>
            </HorizontalFlex>
          </LoginContainer>
        </Container>
      </ShadowLayer>
    </Background>
  );
};

export default ErrorView;
